<template>
    <cadastro-simples-list
        endpoint="causa-baixo-desempenho"
        rota-base="/admin/causa-baixo-desempenho"
        titulo="CAUSAS DE BAIXO DESEMPENHO"
        titulo-singular="Causa de Baixo Desempenho"
        :colunas-extras='[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
